import { LoadingOutlined } from '@ant-design/icons';
import { Col, Row, Spin } from 'antd';
import styled from 'styled-components';

const antIcon = <LoadingOutlined style={{ fontSize: 32 }} spin />;

interface LoadingOverlayProps {
  loading?: boolean;
}

function LoadingOverlay({ loading = false }: LoadingOverlayProps) {
  return loading ? (
    <Overlay>
      <Row style={{ height: '100%' }} justify="center" align="middle">
        <Col>
          <Spin indicator={antIcon} />
        </Col>
      </Row>
    </Overlay>
  ) : null;
}

const Overlay = styled.div`
  height: 100%;
  width: 100%;
  background: rgba(247, 252, 255, 0.53);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
`;

export default LoadingOverlay;
